module.exports = __webpack_public_path__ + "assets/img/oneExtract.b5796996.png";